export default "__VITE_ASSET__b0c2d4db__"